import { Component, inject } from '@angular/core';
import { EdiIncomingOrderResponseListConfigService } from '../../../services/edi-incoming-order-response-list-config/edi-incoming-order-response-list-config.service';

@Component({
    selector: 'lib-edi-incoming-order-response',
    template: `<h3 class="d-block page-title text-center" translate>Manage incoming order responses</h3>
    <lib-filter-list [configService]="ediIncomingOrderResponseListConfigService"></lib-filter-list>`,
    styles: [],
    standalone: false
})
export class EdiIncomingOrderResponseComponent {
  public ediIncomingOrderResponseListConfigService = inject(EdiIncomingOrderResponseListConfigService);

  ngOnInit(): void {}
}
